// extracted by mini-css-extract-plugin
export default {"container":"input_container__Vtd22","header":"input_header__5M+39","input":"input_input__vuNkX"};